<template>
    <div
        v-if="chatTypingIndicators && chatTypingIndicators.count > 0"
        class="active-chat-typing-indicator text-right small text-secondary text-sm"
    >
        <strong>{{ chatTypingIndicators.names }}</strong>
        {{ chatTypingIndicators.count === 1 ? $t("is") : $t("are") }}
        {{ $t("typing") }}
    </div>
</template>

<script type="ts">
import { useChatsStore } from "@/store/useChatsStore";
import useTypingIndicators from "@/views/modules/messaging-inbox/useTypingIndicators";
import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
    setup() {
        const chatsStore = useChatsStore();

        if (!chatsStore.activeChat?.chat) {
            return;
        }

        const { resolveTypingIndicatorsForChat } = useTypingIndicators();
        const chatTypingIndicators = computed(() => resolveTypingIndicatorsForChat(chatsStore.activeChat.chat.id));

        return {
            chatTypingIndicators
        };
    },
});
</script>
